import { useMemo, useEffect, useState } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { Alerts, GetSettings } from "../../../helpers";
import countryList from "react-select-country-list";
import { State } from "country-state-city";
import Select from "react-select";
import MUIDataTable from "mui-datatables";
import { FaEdit, FaTrash } from "react-icons/fa";
import ThemeModal from "../../../components/cmp/ThemeModal";
import ConfModal from "../../../components/cmp/ConfModal";
import ReactCountryFlag from "react-country-flag";
const breadcrumbs = [
    { id: 1, label: "Dashboard", link: "/" },
    { id: 2, label: "Categories", link: "/app/post/categories" },
    { id: 3, label: "Create New", link: "/app/post/categories/create" },
];

const ShippingCountry = () => {
    const [isLoading, setLoading] = useState(true);
    const [shippingCountries, setShippingCountries] = useState([]);
    const [singleShippingCountry, setSingleShippingCountry] = useState(null);
    const [isEdit, setEdit] = useState(false);
      const [states, setStates] = useState([]);

    const handleOpenEdit = (singleRecord) => {
        setSingleShippingCountry(singleRecord);
        setEdit(true)
    }

    const handleCloseEdit = () => {
        setSingleShippingCountry(null);
        setEdit(false)
    }


    const options = useMemo(() => countryList().getData(), []);
    const validationSchema = Yup.object().shape({
        country_code: Yup.string().required("Country is required"),
        country_label: Yup.string().required("Country label is required"),
    });


    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.createShippingZoneCountry(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            getShippingCountries();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
            setSubmitting(false);
        }
    }


    const handleUpdate = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.updateShippingZoneCountry(singleShippingCountry.id, values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            getShippingCountries();
            handleCloseEdit();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
            setSubmitting(false);
        }
    }

    const getShippingCountries = async () => {
        const resp = await GetSettings.getShippingZoneCountries();
        if (resp && resp.status) {
            setShippingCountries(resp.shipping_countries);
            setLoading(false);
        }
    }

    const deleteShippingCountries = async (id) => {
        const resp = await GetSettings.deleteShippingZoneCountry(id);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            getShippingCountries();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }


    useEffect(() => {
        getShippingCountries();
    }, []);

    const columns = [
        {
            name: 'SL'
        },
        {
            name: 'Country',
            sortable: true,
        },
        {
            name: 'Country Name',
            sortable: true,
        },
        {
            name: 'Country Label',
            sortable: true,
        },
        
        {
            name: 'Actions',
            sortable: false,
        },
    ];


    const tableOptions = {
        filter: false,
        search: false,
        download: false,
        print: false,
        selectableRows: 'none'
    };

  const handleCountryChange = (selected) => {
    // setCountry(selected);
    // get states by ISO code
    const statesData = State.getStatesOfCountry(selected);
    console.log(statesData)
    //setStates(statesData.map((s) => ({ value: s.isoCode, label: s.name })));
  };


    return (
        <>
            <Breadcrumb breadcrumbs={breadcrumbs} />
            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Add Shipping Country
                        </h2>

                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-5">

                                    <Formik
                                        initialValues={{
                                            country_code: "",
                                            country_name: "",
                                            country_label: "",
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                            setFieldValue,
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {/* Country Select */}
                                                        <div className="form-group">
                                                            <label>Select Country</label>
                                                            <Select
                                                                options={options}
                                                                value={
                                                                    values.country_code
                                                                        ? {
                                                                            value: values.country_code,
                                                                            label: values.country_name,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(option) => {
                                                                    handleCountryChange(option.value);
                                                                    setFieldValue("country_code", option.value); // GB
                                                                    setFieldValue("country_name", option.label); // United Kingdom
                                                                    setFieldValue("country_label", option.label)
                                                                }}
                                                                onBlur={handleBlur}
                                                                name="country_code"
                                                            />
                                                            {errors.country_code && touched.country_code && (
                                                                <span className="help-error">
                                                                    {errors.country_code}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Country Label */}
                                                        <div className="form-group">
                                                            <label>Country Label</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="country_label"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.country_label}
                                                            />
                                                            {errors.country_label &&
                                                                touched.country_label && (
                                                                    <span className="help-error">
                                                                        {errors.country_label}
                                                                    </span>
                                                                )}
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="text-left">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-block"
                                                                disabled={isSubmitting}
                                                                style={{
                                                                    marginTop: "30px",
                                                                    width: "100%",
                                                                    maxWidth: "150px",
                                                                }}
                                                            >
                                                                {isSubmitting ? "Submitting..." : "Submit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                                <div className="col-md-7">

                                    <MUIDataTable
                                        title={`Shipping Countries`}
                                        data={shippingCountries.map((item, i) => {
                                            return [
                                                ++i,
                                                <ReactCountryFlag
                                                    countryCode={item.country_code}
                                                    svg
                                                    cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                    style={{
                                                        fontSize: '1.5em',
                                                    }}
                                                />,
                                                item.country_name,
                                                item.country_label,
                                                <div className={`actions`}>
                                                    <button onClick={() => handleOpenEdit(item)} className="btn btn-info btn-sm"><FaEdit /></button> | <ConfModal delId={item.id} handleDelete={deleteShippingCountries} message={'Are you sure you want delete this record!'} />
                                                </div>
                                            ]
                                        })}
                                        columns={columns}
                                        options={tableOptions}
                                    />
                                </div>
                            </div>
                            {
                                singleShippingCountry !== null && <ThemeModal show={isEdit} handleHide={handleCloseEdit} title={'Update Shipping Countries'} >
                                    <Formik
                                        enableReinitialize={true}
                                        initialValues={{
                                            country_code: singleShippingCountry.country_code,
                                            country_name: singleShippingCountry.country_name,
                                            country_label: singleShippingCountry.country_label
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleUpdate}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                            setFieldValue,
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {/* Country Select */}
                                                        <div className="form-group">
                                                            <label>Select Country</label>
                                                            <Select
                                                                options={options}
                                                                value={
                                                                    values.country_code
                                                                        ? {
                                                                            value: values.country_code,
                                                                            label: values.country_name,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(option) => {
                                                                    setFieldValue("country_code", option.value); // GB
                                                                    setFieldValue("country_name", option.label); // United Kingdom
                                                                    setFieldValue("country_label", option.label)
                                                                }}
                                                                onBlur={handleBlur}
                                                                name="country_code"
                                                            />
                                                            {errors.country_code && touched.country_code && (
                                                                <span className="help-error">
                                                                    {errors.country_code}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Country Label */}
                                                        <div className="form-group">
                                                            <label>Country Label</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="country_label"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.country_label}
                                                            />
                                                            {errors.country_label &&
                                                                touched.country_label && (
                                                                    <span className="help-error">
                                                                        {errors.country_label}
                                                                    </span>
                                                                )}
                                                        </div>

                                                        {/* Submit Button */}
                                                        <div className="text-center">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary btn-block"
                                                                disabled={isSubmitting}
                                                                style={{
                                                                    marginTop: "30px",
                                                                    width: "100%",
                                                                    maxWidth: "150px",
                                                                }}
                                                            >
                                                                {isSubmitting ? "Submitting..." : "Submit"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </ThemeModal>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ShippingCountry;
